import PropTypes from 'prop-types';
import React from 'react';
import BsButton from 'react-bootstrap/es/Button';
/**
 * This is the Button component, a direct proxy of
 * [React Bootstrap's Button](https://react-bootstrap.github.io/components/buttons/).
 */

var Button = function Button(props) {
  return React.createElement(BsButton, props);
};

Button.displayName = 'Button';
Button.propTypes = {
  /**
   * Manually set the visual state of the button to :active
   */
  active: PropTypes.bool,

  /**
   * You can use a custom element type for this component.
   *
   * @see [Button tags](https://react-bootstrap.github.io/components/buttons/#button-tags)
   */
  as: PropTypes.elementType,

  /**
   * Spans the full width of the Button parent
   */
  block: PropTypes.bool,

  /**
   * Disables the Button, preventing mouse events, even if the
   * underlying component is an <a> element
   */
  disabled: PropTypes.bool,

  /**
   * Providing a href will render an <a> element, styled as a button.
   */
  href: PropTypes.string,

  /**
   * Defines HTML button type attribute.
   */
  type: PropTypes.oneOf(['button', 'reset', 'submit']),

  /**
   * The theme of the button
   *
   * @see See [React Bootstrap's Button](https://react-bootstrap.github.io/components/buttons/)
   */
  variant: PropTypes.oneOf(['primary', 'outline-primary', 'secondary', 'outline-secondary', 'success', 'outline-success', 'warning', 'outline-warning', 'danger', 'outline-danger', 'info', 'outline-info', 'light', 'outline-light', 'dark', 'outline-dark', 'link']),

  /**
   * The size of the button
   *
   * @see See [React Bootstrap's Sizes](https://react-bootstrap.github.io/components/buttons/#sizes)
   */
  size: PropTypes.oneOf(['sm', 'lg'])
};
Button.defaultProps = {
  active: false,
  variant: 'secondary',
  disabled: false,
  type: 'button'
};
export default Button;